export const getProcessingNotification = (state) => ({
  isShow: state.processingNotification.isShow,
  title: state.processingNotification.title,
});
